import _ from "lodash";
import { getGlobalRelationAttributes } from "@/lib/thingUtils";
import { get, post } from "@/services/api.services";
import axios from "@/lib/apiAxios.js";

/**
 * @deprecated
 */
export async function fetchThingsDataSchemaAndGlobals({
    protocolCode,
    experimentCode,
    entityName,
    parent,
}) {
    console.log(
        "fetchThingsDataSchemaAndGlobals",
        protocolCode,
        experimentCode,
        entityName,
        parent
    );

    // Fetch attributes data
    const schemaRes = await fetchMergedThingSchema(protocolCode, entityName, parent);
    const mangoSchema = schemaRes.attributes;

    // Extract global attribute objects
    const attributesArray = Object.values(mangoSchema);
    const globalOptionsByRelation = await buildGlobalRelationOptionsByRelationForAttributes(
        attributesArray,
        experimentCode
    );

    // TODO: I'm quite sure there's a better API to call than fetching _all_ things and filtering locally.
    const entityRes = await fetchThingDataForExperiment(experimentCode);
    const entityDatas = _.filter(entityRes, { schema_name: entityName, schema_parent: parent });
    const entityDataMap = _.map(entityDatas, "data");

    entityDataMap.forEach(function (entity, i) {
        // Add names to entityData obj
        const entityData = entityDatas[i];
        entity.display_name = entityData.display_name || entityData.id;
        entity.id = entityData.id;
        entity.is_benchling = entityData.is_benchling;
        // Map global entities 'file_registry_id$' => 'name' ('TIP001' -> 'myTip')
        Object.keys(entity).forEach((attributeName) => {
            const attribute = mangoSchema[attributeName];
            if (attribute && attribute.type === "global_relation") {
                const options = globalOptionsByRelation[attribute.relation];
                const currentValue = entity[attributeName];
                const currentOption = options.find((option) => {
                    return option.value === currentValue;
                });
                entity[attributeName] = currentOption ? currentOption.title : currentValue;
            }
        });
    });

    const schema = {};
    Object.keys(mangoSchema).forEach((attribute, i) => {
        const attr = mangoSchema[attribute];
        if (attr.widget_type === "numeric_w_units") {
            const attrBase = {
                ...attr,
                widget_type: "numeric_w_units",
            };
            const attrUnits = {
                ...attr,
                name: attr.name + "_units",
                type: "string",
                widget_type: "dropdown",
                options: attr.options,
                display_name: attr.display_name + " Units",
                display_order: attr.display_order + 1,
            };
            schema[attribute] = attrBase;
            schema[attribute + "_units"] = attrUnits;
        } else {
            schema[attribute] = attr;
        }
    });

    return {
        schema,
        entityDataMap,
        globalMapObject: globalOptionsByRelation,
    };
}

/**
 * @deprecated
 */
async function fetchGlobalRelations(relations, experimentCode) {
    const relationOptionsByRelation = {};
    for (const relation of relations) {
        // TODO: this API should return options, not this confusing array of arrays Map construct.
        const arrayOfIdToValueObjects = await fetchGlobalThingMapForRelation(
            relation,
            experimentCode
        );
        relationOptionsByRelation[relation] = arrayOfIdToValueObjects.map(([value, label]) => {
            return {
                title: label,
                value,
            };
        });
    }

    return relationOptionsByRelation;
}

/**
 * @deprecated use protocol.relationOptions and getGlobalRelationOptionsForRelation
 */
export async function buildGlobalRelationOptionsByRelationForAttributes(
    attributesList,
    experimentCode
) {
    const globalRelationAttributes = getGlobalRelationAttributes(attributesList);
    const relations = getUniqueRelationsForEntryRelationAttributes(globalRelationAttributes);
    return fetchGlobalRelations(relations, experimentCode);
}

function getUniqueRelationsForEntryRelationAttributes(entryRelationAttributes) {
    const relations = entryRelationAttributes.map((attribute) => attribute.relation);
    return [...new Set(relations)];
}

/**
 * @deprecated
 */
export async function fetchGlobalThingMapForRelation(relationName) {
    // Note: does not use Amplify
    // https://github.com/vl43inc/mono/blob/main/apps/lab-api/src/routes/mango.ts#L97
    // https://github.com/vl43inc/mono/blob/main/apps/lab-api/src/lib/mapping.ts#L50
    return get(`/mango/get_global_thing_map/`, { params: { thing: relationName } });
}

/**
 * @deprecated
 */
export async function fetchThingDataForExperiment(experimentCode) {
    // Note: does not use Amplify
    // https://github.com/vl43inc/mono/blob/main/apps/lab-api/src/routes/mango.ts#L63
    // https://github.com/vl43inc/mono/blob/main/apps/lab-api/src/models/mango.ts#L25
    return get(`/mango/fetch_entity_data/${experimentCode}`);
}

/**
 * @deprecated
 */
export async function fetchMergedThingSchema(protocolCode, entityName, entityParent) {
    // Note: does not use Amplify
    // https://github.com/vl43inc/mono/blob/main/apps/lab-api/src/routes/mango.ts#L42
    // https://github.com/vl43inc/mono/blob/main/apps/lab-api/src/models/mango.ts#L82
    return get(`/mango/fetch_merged_entity_schema/${protocolCode}/${entityName}/${entityParent}`);
}

/**
 * @deprecated
 */
export async function fetchAllEntityDataOTForExperimentCode(experimentCode, timeZone) {
    // Fetch Mango experiment data
    let tzString = "utc";
    if (timeZone) {
        tzString = timeZone.replace(/\//g, "%2F");
    }

    // Note: does not use Amplify
    // https://github.com/vl43inc/mono/blob/main/apps/lab-api/src/routes/mango.ts#L136
    // https://github.com/vl43inc/mono/blob/main/apps/lab-api/src/models/mango.ts#L188
    return get(`/mango/fetch_all_entity_data_ot_by_exp/${experimentCode}/${tzString}`);
}

/**
 * @deprecated
 */
export async function fetchEntitySchemasByProtocolCode(protocolCode) {
    // Note: does not use Amplify
    // https://github.com/vl43inc/mono/blob/main/apps/lab-api/src/routes/mango.ts#L20
    // https://github.com/vl43inc/mono/blob/main/packages/%40invaio/mango-utils/repository/thingRepository.ts#L757
    return get(`/mango/fetch_entity_schemas_by_protocol/${protocolCode}`);
}

/**
 * @deprecated
 */
export async function fetchAllMergedEntitySchemasByProtocol(protocolId) {
    // Note: does not use Amplify
    // https://github.com/vl43inc/mono/blob/main/apps/lab-api/src/routes/mango.ts#L31
    // https://github.com/vl43inc/mono/blob/main/packages/%40invaio/mango-utils/repository/thingRepository.ts#L780
    return await axios.get(`/mango/fetch_all_merged_entity_schemas_by_protocol/${protocolId}`);
}

export async function uploadLegacyOTDataFile(file) {
    const formData = new FormData();
    formData.set("file", file);
    return post(`/legacyUpdateOTData`, formData);
}
